import validator from 'validator';

export default function emailValidator(value) {
    const parsed = {
        isValid: false,
        formattedValue: null,
        errorText: null
    };

    if (validator.isEmail(value)) {
        parsed.isValid = true;
    }
    else {
        parsed.errorText = 'Email address does not have the right format (email@domain.com).';
    }

    return parsed;
}
